module.exports = __webpack_public_path__ + "img/960w.0e54131.jpg";